declare const JSZip;

/**
  * A helper service with the ability to read files
  */
export class FileReaderService {
  constructor(private $q: ng.IQService) {
  }

  /**
   * Reads the data from a file object
   * @param file the file to get data from
   * @returns a promise of a data object
   */
  public readDataFromFile = (file: File) => {
    if (this.fileIsOfType(file.name, 'zip')) {
      return this.readZipFile(file);
    } else if (this.fileIsOfType(file.name, 'json')) {
      return this.readTextFile(file);
    }
  }

  /**
   * Determines if the fileName entered contains the extension entered
   * @param fileName the name of the file
   * @param extension the extension to find
   * @returns true if the extension is found at the end of the fileName
   */
  private fileIsOfType = (fileName: string, extension: string) => {
    return fileName.split('.').pop() === extension;
  }

  /**
   * Reads a zip file for the first file and extracts a json data object from it.
   * @param file the zip file to extract data from
   * @returns a promise of a data object
   */
  private readZipFile = (file: File) => {
    const deferred = this.$q.defer();
    const fileReader = new FileReader();
    fileReader.onload = (e: any) => {
      const zipFileLoaded = new JSZip(e.target.result);
      let fileName = '';
      for (const nameOfFileContainedInZipFile in zipFileLoaded.files) {
        fileName = nameOfFileContainedInZipFile;
      }
      const data = zipFileLoaded.files[fileName].asText();
      if (this.isValidJson(data)) {
        deferred.resolve(angular.fromJson(data));
      } else {
        deferred.reject();
      }
    };
    fileReader.readAsArrayBuffer(file);
    return deferred.promise;
  }

  /**
   * Reads a text file and extracts a json data object from it.
   * @param file the text file to extract data from
   * @returns a promise of a data object
   */
  private readTextFile = (file: File) => {
    const deferred = this.$q.defer();
    const fileReader = new FileReader();
    fileReader.onload = (e: any) => {
      const data = e.target.result;
      if (this.isValidJson(data)) {
        deferred.resolve(angular.fromJson(data));
      } else {
        deferred.reject();
      }
    };
    fileReader.readAsText(file);
    return deferred.promise;
  }

  /**
   * Determines if the data entered is valid json
   * @param data the data in string form
   * @returns true if data is valid json
   */
  private isValidJson = (data: string) => {
    try {
      JSON.parse(data);
    } catch (e) {
      return false;
    }
    return true;
  }
}